/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import React, { ComponentType, FunctionComponent } from 'react';
import { Loader } from '@scuf/common';
import './MSLoadingStatus.scss';
export interface ILoadingStatusProps {
  loading?: boolean;
  loadingText: string;
  statusCode?: number | null;
  silentLoading?: boolean;
}

const withMSLoadingStatus = <P extends Object>(
  WrappedComponent: ComponentType<P>
): FunctionComponent<P & ILoadingStatusProps> =>
  React.memo(
    ({
      loading,
      loadingText,
      silentLoading,
      ...props
    }: ILoadingStatusProps) => {
      return (loading && !silentLoading) || props.statusCode === 0 ? (
        <div className="mobilesupervisorloader-container">
          <Loader loading={true} text={loadingText} />
        </div>
      ) : (
        <WrappedComponent {...(props as P)} />
      );
    }
  );

export default withMSLoadingStatus;
